import { defineMessages } from 'react-intl';

import globalMessages from '../../utils/globalMessages';

const messages = defineMessages({
    ...globalMessages,

    title: {
        id: 'transactions.title',
        defaultMessage: 'Recebimento',
    },

    titleTransaction: {
        id: 'transactions.titleTransaction',
        defaultMessage: 'Recebimento {entity}',
    },

    btnNewInvoice: {
        id: 'transactions.btnNewInvoice',
        defaultMessage: 'Nova Nota Fiscal',
    },

    registrationInfo: {
        id: 'transactions.registrationInfo',
        defaultMessage: 'Informações Recebimento',
    },

    name: {
        id: 'global.name',
        defaultMessage: 'Nome',
    },

    cnpj: {
        id: 'global.cnpj',
        defaultMessage: 'CPF/CNPJ',
    },

    email: {
        id: 'global.email',
        defaultMessage: 'E-mail',
    },

    city: {
        id: 'global.city',
        defaultMessage: 'Cidade',
    },

    state: {
        id: 'global.state',
        defaultMessage: 'Estado',
    },

    home: {
        id: 'home.title',
        defaultMessage: 'Início',
    },
});

export default messages;
